export const stringToNumerableEnum = <T extends number>(clss: () => T, value: string): T => {
  let type: T = ('' as unknown) as T;
  if (Object.keys(clss).find((t: string) => t === value.toString().toUpperCase())) {
    type = clss[value.toString().toUpperCase() as keyof typeof clss];
  } else {
    console.error(`not valid format of type variable: ${value}`);
  }
  return type;
};
